export default __webpack_public_path__ + "static/Imran-Jawaid-97314687afcc5f556171a9c39391d206.png";